/**
 * The API writes some audit descriptions in English (older events). In Portuguese they are shown translated; anything
 * not recognized is shown as it came. Names, e-mails and reasons are kept as written.
 */
const PT_RULES: [RegExp, (...m: string[]) => string][] = [
  [/^Signature request created with (\d+) recipient\(s\)$/, (_, n) => `Pedido de assinatura criado com ${n} assinante(s)`],
  [/^Signature request cancelled: ([\s\S]+)$/, (_, r) => `Pedido de assinatura cancelado: ${r}`],
  [/^Signature request cancelled$/, () => "Pedido de assinatura cancelado"],
  [/^Signature request expired$/, () => "Pedido de assinatura expirou"],
  [/^Document viewed by (.+)$/, (_, n) => `Documento visualizado por ${n}`],
  [/^Signature applied by (.+)$/, (_, n) => `Assinatura feita por ${n}`],
  [/^All signatures collected \(manual completion\)$/, () => "Todas as assinaturas coletadas (conclusão manual)"],
  [/^All signatures collected$/, () => "Todas as assinaturas coletadas"],
  [/^Document declined by ([^:]+): ([\s\S]*)$/, (_, n, r) => `Documento recusado por ${n}: ${r}`],
  [/^Signature manually completed for (.+)$/, (_, n) => `Assinatura concluída manualmente para ${n}`],
  [/^Signer cancelled: (.+?) Reason: ([\s\S]*)$/, (_, n, r) => `Assinante cancelado: ${n}. Motivo: ${r}`],
  [/^GOV\.BR signature of (.+) checked in the returned file$/, (_, n) => `Assinatura gov.br de ${n} conferida no arquivo devolvido`],
  [/^GOV\.BR signature of (.+) approved by the sender$/, (_, n) => `Assinatura gov.br de ${n} aprovada pelo remetente`],
  [/^GOV\.BR: reminder sent to (.+) by WhatsApp$/, (_, n) => `gov.br: lembrete enviado para ${n} pelo WhatsApp`],
  [/^GOV\.BR: (reminder with the file to sign|file to sign) sent to (.+) by (e-mail and WhatsApp|e-mail|WhatsApp)$/, (_, what, n, how) =>
    `gov.br: ${what === "file to sign" ? "arquivo para assinar" : "lembrete com o arquivo para assinar"} enviado para ${n} por ${how === "e-mail and WhatsApp" ? "e-mail e WhatsApp" : how}`],
  [/^Signing order changed by the sender: (.*) \(before: (.*)\)\.(?: (.+) signs next and gets the file; (.+) waits for their turn\.)?$/, (_, now, before, next, waits) =>
    `Ordem de assinatura alterada pelo remetente: ${now} (antes: ${before}).` + (next ? ` ${next} assina agora e recebe o arquivo; ${waits} aguarda a vez.` : "")],
];

export function localizeAuditText(text: string | null | undefined, language: string): string {
  const s = (text ?? "").trim();
  if (!s || language !== "pt") return text ?? "";
  for (const [re, fn] of PT_RULES) {
    const m = re.exec(s);
    if (m) return fn(...(m as unknown as string[]));
  }
  return s;
}
